//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DataTable from '../../general/DataTable';
import moment from 'moment';
export default {
  name: 'ActivitiesTable',
  components: {
    DataTable: DataTable
  },
  props: {
    data: {
      type: Array,
      default: null
    },
    person: {
      type: Object,
      default: null
    }
  },
  computed: {
    headerDefinition: function headerDefinition() {
      return [{
        name: t('health', 'Date'),
        columnId: 'datetime',
        type: 'datetime',
        show: true,
        default: function _default() {
          return moment().format('YYYY-MM-DDTHH:mm');
        }
      }, {
        name: t('health', 'Burned calories'),
        columnId: 'calories',
        type: 'number',
        show: this.person.activitiesColumnCalories,
        suffix: ' ' + t('health', 'kcal', {})
      }, {
        name: t('health', 'Activity duration'),
        columnId: 'duration',
        type: 'number',
        show: this.person.activitiesColumnDuration,
        suffix: ' ' + t('health', 'min.', {})
      }, {
        name: t('health', 'Distance'),
        columnId: 'distance',
        type: 'number',
        show: this.person.activitiesColumnDistance,
        suffix: ' ' + (this.person.activitiesDistanceUnit ? this.person.activitiesDistanceUnit : '')
      }, {
        name: t('health', 'Category'),
        columnId: 'category',
        type: 'select',
        options: [{
          id: 0,
          label: t('health', 'Running')
        }, {
          id: 1,
          label: t('health', 'Yoga')
        }, {
          id: 2,
          label: t('health', 'Gymnastics')
        }, {
          id: 3,
          label: t('health', 'Climbing')
        }, {
          id: 4,
          label: t('health', 'Fitness')
        }, {
          id: 5,
          label: t('health', 'Workout')
        }, {
          id: 6,
          label: t('health', 'Job')
        }, {
          id: 7,
          label: t('health', 'Biking')
        }, {
          id: 8,
          label: t('health', 'Swimming')
        }, {
          id: 9,
          label: t('health', 'Walking')
        }, {
          id: 10,
          label: t('health', 'Cardio')
        }, {
          id: 11,
          label: t('health', 'Driving')
        }, {
          id: 12,
          label: t('health', 'eSports')
        }, {
          id: 13,
          label: t('health', 'Martial arts')
        }, {
          id: 14,
          label: t('health', 'Team sports')
        }, {
          id: 15,
          label: t('health', 'Sports with animals')
        }, {
          id: 16,
          label: t('health', 'Adventure sports')
        }, {
          id: 17,
          label: t('health', 'Mind sports')
        }, {
          id: 18,
          label: t('health', 'Water sports')
        }, {
          id: 19,
          label: t('health', 'Other')
        }],
        show: this.person.activitiesColumnCategory
      }, {
        name: t('health', 'Feeling after activity'),
        columnId: 'feeling',
        type: 'select',
        options: [{
          id: 0,
          label: t('health', 'Fantastic', {})
        }, {
          id: 1,
          label: t('health', 'Good', {})
        }, {
          id: 2,
          label: t('health', 'Okay', {})
        }, {
          id: 3,
          label: t('health', 'Bad', {})
        }, {
          id: 4,
          label: t('health', 'Horrible', {})
        }],
        show: this.person.activitiesColumnFeeling
      }, {
        name: t('health', 'Training intensity'),
        columnId: 'intensity',
        type: 'select',
        options: [{
          id: 0,
          label: t('health', 'Low', {})
        }, {
          id: 1,
          label: t('health', 'Medium', {})
        }, {
          id: 2,
          label: t('health', 'High', {})
        }, {
          id: 3,
          label: t('health', 'Very high', {})
        }],
        show: this.person.activitiesColumnIntensity
      }, {
        name: t('health', 'Comment'),
        columnId: 'comment',
        type: 'longtext',
        show: true
      }];
    }
  },
  methods: {
    addItem: function addItem(item) {
      // console.debug('add item', item)
      this.$store.dispatch('activitiesDatasetsAppend', item);
    },
    updateItem: function updateItem(item) {
      console.debug('update item', item);
      this.$store.dispatch('activitiesDatasetsUpdate', item);
    },
    deleteItem: function deleteItem(item) {
      // console.debug('delete item', item)
      this.$store.dispatch('activitiesDatasetsDelete', item);
    }
  }
};